import List from 'list.js';

const ELEMENTS = document.querySelectorAll('.js-TableListFilter')
const options = {
  searchClass: 'filter-search-input',
  listClass: 'js-TableListFilter-tbody',
  valueNames: [ 'symbol' ]
};

class TableListFilter {
  constructor() {
    ELEMENTS.forEach((el) => {
      const list = new List(el, options);

      list.on('updated', function(list) {
        if (list.matchingItems.length == 0) {
          el.classList.add('is-empty')
        } else {
          el.classList.remove('is-empty')
        }
      })
    })

  }
}


new TableListFilter()
